import { FoundationInput } from '@core/const'
import { FoundationResponse } from '@core/query'
import { Dispatch, PropsWithChildren, SetStateAction, createContext, useContext, useMemo, useState } from 'react'
import { UseFormReturn, useForm } from 'react-hook-form'

const defaultFormValues: FoundationInput = {
  longSideSpan: 0,
  shortSideSpan: 0,
  usage: 'RESIDENTIAL',
  slabThickness: 0,
  stories: 0,
  floorHeight: 5,
  concreteStrength: 30,
  bearingCapacity: 0,
  criterionSize: 0,
}

interface FoundationContext {
  form: UseFormReturn<FoundationInput>
  result: FoundationResponse | null
  setResult: Dispatch<SetStateAction<FoundationResponse | null>>
}

const context = createContext<FoundationContext | undefined>(undefined)

const useDefaultContextValues = () => {
  const form = useForm<FoundationInput>({
    defaultValues: defaultFormValues,
  })

  const [result, setResult] = useState<FoundationResponse | null>(null)

  return useMemo(() => ({
    form,
    result,
    setResult,
  }), [form, result])
}

export function FoundationProvider ({ children }: PropsWithChildren) {
  const { Provider } = context
  const defaultContextValues = useDefaultContextValues()

  return (
    <Provider value={defaultContextValues}>
      {children}
    </Provider>
  )
}

export const useFoundation = () => {
  const contextValues = useContext(context)
  const defaultContextValues = useDefaultContextValues()

  return contextValues ?? defaultContextValues
}
